module.exports = __webpack_public_path__ + "bb35c5004d6a962e80889da60e371af2.svg";